import styles from '@ui/components/Voting/components/Raffle/Raffle.module.scss';
import Button from '@ui/components/Button/Button';
import Checkbox from '@ui/components/Checkbox/Checkbox';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import InputField, { InputMessage } from '@ui/components/InputField/InputField';
import Link from '@ui/components/Link/Link';
import Radio from '@ui/components/Radio/Radio';
import React from 'react';
import {
  Form,
  FormCheckbox,
  FormRadio,
  FormRadioGroup,
  FormSubmit,
} from '@ariakit/react';
import { getHeadingTag } from '../../../../utils';

const RaffleForm = ({
  headingLevel,
  formContent,
  legalLabel,
  legalText,
  raffleContent,
  raffleTitle,
  store,
}) => (
  <Form store={store}>
    {raffleTitle && (
      <Heading as={getHeadingTag(headingLevel)} noSpacing size="h5">
        {raffleTitle}
      </Heading>
    )}
    {formContent && <Content withParser>{raffleContent}</Content>}
    <FormRadioGroup
      className={styles.salutationWrapper}
      name="anrede"
      store={store}
    >
      <FormRadio
        label="Frau"
        name="anrede"
        render={<Radio />}
        store={store}
        value="female"
        variant="horizontal"
      />
      <FormRadio
        label="Herr"
        name="anrede"
        render={<Radio />}
        store={store}
        value="male"
        variant="horizontal"
      />
      <FormRadio
        label="Divers"
        name="anrede"
        render={<Radio />}
        store={store}
        value="non-binary"
        variant="horizontal"
      />
    </FormRadioGroup>
    <div className={styles.inputWrapper}>
      <InputField
        label="Vorname"
        name="vorname"
        store={store}
        variant="closed"
      />
      <InputField
        className={styles.secondInput}
        label="Nachname"
        name="nachname"
        store={store}
        variant="closed"
      />
      <InputField
        label="E-Mail"
        name="email"
        store={store}
        type="email"
        variant="closed"
      />
      <InputField
        className={styles.secondInput}
        label="Telefon"
        name="telefon"
        store={store}
        variant="closed"
      />
    </div>
    <InputMessage name="topics" store={store} />
    <FormCheckbox
      className={styles.acceptedCheckbox}
      name="accepted"
      render={
        <Checkbox
          label={
            <Content noSpacing size="sm" withParser>
              {legalLabel}
            </Content>
          }
        />
      }
      store={store}
    />
    <InputMessage name="accepted" store={store} />
    <Content className={styles.legalText} noSpacing withParser>
      {legalText}
    </Content>
    <FormSubmit
      className={styles.button}
      isElevated
      render={<Button />}
      store={store}
      type="submit"
    >
      Abschicken
    </FormSubmit>
  </Form>
);

const RaffleFinal = ({
  headingLevel = 5,
  finalTitle,
  finalContent,
  finalSubtitle,
  finalLink,
}) => (
  <>
    <Heading
      as={getHeadingTag(headingLevel)}
      className={styles.finalHeader}
      size="h5"
    >
      {finalTitle}
    </Heading>
    <Content withParser>{finalContent}</Content>
    <Heading as="p" className={styles.finalHeader} size="h6">
      {finalSubtitle}
    </Heading>
    {finalLink && (
      <Button
        className={styles.finalButton}
        isElevated
        render={<Link target={finalLink.target} to={finalLink.url} />}
      >
        {finalLink.title}
      </Button>
    )}
  </>
);

export { RaffleForm, RaffleFinal };
